import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators'
import store from '@/store'

export interface IAppState {
  isRequestActive: boolean
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  public isRequestActive = false;

  @Mutation
  private SET_REQUEST_ACTIVE(isActive: boolean): void {
    this.isRequestActive = isActive
  }

  @Action
  public async setIsRequestActive(isActive: boolean): Promise<boolean> {
    this.SET_REQUEST_ACTIVE(isActive)
    return isActive
  }
}

export const AppModule = getModule(App)
